// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import OneToOneOutlinedSvg from "@fishx/icons-svg/es/asn/OneToOneOutlined";
import FishxIcon from '../components/FishxIcon';

var OneToOneOutlined = function OneToOneOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: OneToOneOutlinedSvg
  }));
};

OneToOneOutlined.displayName = 'OneToOneOutlined';
export default React.forwardRef(OneToOneOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/OneToOneOutlined.js
// module id = 3184
// module chunks = 0